import { Download, X } from 'lucide-react';
import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { useInstallPrompt } from '@/hooks/useInstallPrompt';
import { cn } from '@/lib/utils';

export function InstallPrompt() {
  const { isInstallable, isInstalled, promptInstall } = useInstallPrompt();
  const [dismissed, setDismissed] = useState(false);
  const [isInstalling, setIsInstalling] = useState(false);

  if (!isInstallable || isInstalled || dismissed) return null;

  const handleInstall = async () => {
    setIsInstalling(true);
    await promptInstall();
    setIsInstalling(false);
  };

  return (
    <div 
      className={cn(
        "fixed bottom-6 left-1/2 -translate-x-1/2 z-50",
        "bg-card border border-border shadow-2xl rounded-2xl",
        "px-4 py-3 flex items-center gap-3",
        "animate-in slide-in-from-bottom-4 fade-in duration-300",
        "max-w-[calc(100vw-2rem)]"
      )}
    >
      <div className="flex items-center gap-3">
        <div className="h-10 w-10 rounded-xl bg-primary/10 flex items-center justify-center">
          <Download className="h-5 w-5 text-primary" />
        </div>
        <div className="flex flex-col">
          <span className="text-sm font-medium">Instalar FreelaDash</span>
          <span className="text-xs text-muted-foreground">Acesse mais rápido e use offline</span>
        </div>
      </div>
      
      <div className="flex items-center gap-2 ml-2">
        <Button
          size="sm"
          onClick={handleInstall}
          disabled={isInstalling}
          className="rounded-xl"
        >
          {isInstalling ? 'Instalando...' : 'Instalar'}
        </Button>
        <Button
          size="icon"
          variant="ghost"
          className="h-8 w-8 rounded-xl"
          onClick={() => setDismissed(true)}
        >
          <X className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
}
